const GlobalConfig = {
    ENVIRONMENT: process.env.VUE_APP_ENVIRONMENT,
    BASE_URL: process.env.VUE_APP_BASE_URL,
    API_URL: process.env.VUE_APP_API_BASE_URL,
    UMBRACO_API_URL: process.env.VUE_APP_UMBRACO_SERVICE,
	PORTAL_BASE_URL: process.env.VUE_APP_PROD_BASE_URL,
	UMBRACO_BASE_URL: process.env.VUE_APP_UMBRACO_BASE_URL,
    APP_INSIGHT_KEY: process.env.VUE_APP_APPLICATION_INSIGHT_KEY,
    FORMSTACK_BASE_SURVEY_URL: process.env.VUE_APP_FORMSTACK_BASE_SURVEY_URL,
    ENCUESTA_BASE_URL: process.env.VUE_APP_ENCUESTA_BASE_URL,
    PUBLIC_WEB_URL : process.env.VUE_APP_PUBLIC_WEB_BASE_URL,
    BIOMETRIC_VALIDATION :process.env.VUE_APP_BIOMETRIC_VALIDATION
}

export default GlobalConfig;